import React from "react";
import { FaTimes } from "react-icons/fa";
import { CATEGORIES_ARABIC } from "../constants/categories";
import { getCategoryLabel } from "../utils/orderCategories";
import "./OrderCategoriesField.css";

const OrderCategoriesField = ({
  categories = [],
  error,
  disabled = false,
  onChange,
  groupClassName = "input-group",
  showError = true,
}) => {
  const selectedCategories = Array.isArray(categories) ? categories.filter(Boolean) : [];
  const availableCategories = Object.entries(CATEGORIES_ARABIC).filter(
    ([category]) => !selectedCategories.includes(category)
  );

  const handleSelect = (event) => {
    const category = event.target.value;
    if (!category) return;

    onChange([...selectedCategories, category]);
  };

  const handleRemove = (categoryToRemove) => {
    onChange(selectedCategories.filter((category) => category !== categoryToRemove));
  };

  return (
    <div className={`${groupClassName} order-categories-field`}>
      <label>الأصناف</label>

      {!disabled && (
        <select value="" onChange={handleSelect} disabled={availableCategories.length === 0}>
          <option value="" disabled>
            {availableCategories.length > 0 ? "اختر صنف" : "تم اختيار كل الأصناف"}
          </option>
          {availableCategories.map(([key, value]) => (
            <option key={key} value={key}>
              {value}
            </option>
          ))}
        </select>
      )}

      <div className={`category-chips ${selectedCategories.length === 0 ? "empty" : ""}`}>
        {selectedCategories.length > 0 ? (
          selectedCategories.map((category) => (
            <span key={category} className="category-chip">
              <span>{getCategoryLabel(category)}</span>
              {!disabled && (
                <button
                  type="button"
                  className="category-chip-remove"
                  onClick={() => handleRemove(category)}
                  aria-label={`إزالة ${getCategoryLabel(category)}`}
                >
                  <FaTimes />
                </button>
              )}
            </span>
          ))
        ) : (
          <span className="category-empty-text">لم يتم اختيار أصناف</span>
        )}
      </div>

      {showError && error && <small className="error-text">{error}</small>}
    </div>
  );
};

export default OrderCategoriesField;
